












































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import {
  InviteCodeList,
  BanApplyInviteCode,
  ChangeInviteCode,
} from "@/request/yonghuquanxian";
import Pagination from "@/components/paginaiton.vue";
import MainHeader from "../../main/components/main-header/main-header.vue";
import NavLeft from "../components/nav-left.vue";
@Component({
  components: {
    Pagination,
    MainHeader,
    NavLeft,
  },
})
export default class YqmList extends Vue {
  private window: any = window;
  private filter: any = {
    current_page: 1,
    page_count: 10,
    sort_value: "0",
  };
  private totalCount: any = 0;
  private totalPage: any = 0;
  private codes: any[] = [];
  private code: any = {};
  private ifShowChangeCode: boolean = false;
  private get localFilter() {
    if (!localStorage.getItem("yqmFilter")) {
      return {};
    } else {
      return JSON.parse(localStorage.getItem("yqmFilter") || "");
    }
  }
  private set localFilter(val) {
    if (!val) {
      return;
    }
    localStorage.setItem("yqmFilter", JSON.stringify(val));
  }
  /**
   * @description 获取邀请码列表
   */
  private fetchCodes() {
    const params: any = this.filter;
    InviteCodeList(this, params).then((data: any) => {
      this.localFilter = this.filter;
      this.codes = data.codes;
      this.totalCount = data.total_count;
      this.totalPage = data.total_page;
    });
  }
  /**
   * @description 搜索
   */
  private search() {
    this.filter.current_page = 1;
    this.fetchCodes();
    // this.fetchJigouList();
  }
  /**
   * @description 处理排序变化
   */
  private handleSortChange(ev: any) {
    this.filter.sort_value = ev["order"] === "ascending" ? "1" : "0";
    this.search();
  }
  /**
   * @description 处理页码变化
   */
  private handleCurrentPageChange(val) {
    this.filter.current_page = val;
    this.fetchCodes();
  }
  /**
   * @description 自动计算所属层级
   */
  private calCengji(jigou) {
    let jigouText = "";
    jigou["组织机构"].forEach((j: any) => {
      jigouText += j["名称"] + "-";
    });
    jigouText = jigouText.substring(0, jigouText.length - 1);
    return jigouText;
  }
  /**
   * @description 打开修改邀请码弹窗
   */
  private openChangeInviteCodeDialog(code) {
    this.code = code;
    this.ifShowChangeCode = true;
  }
  /**
   * @description 修改邀请码
   */
  private changeInviteCode() {
    if (!this.code["new_code"]) {
      this.$message.warning("新邀请码不能为空");
      return;
    }
    if (!this.code["re_code"]) {
      this.$message.warning("请再次输入邀请码");
      return;
    }
    if (this.code["new_code"] !== this.code["re_code"]) {
      this.$message.warning("两次输入的邀请码不一致，请重新填写");
      return;
    }
    const params: any = {
      code_id: this.code.code_id,
      code: this.code["new_code"],
    };
    ChangeInviteCode(this, params).then((data: any) => {
      this.$message.success("修改成功");
      this.ifShowChangeCode = false;
      this.code = {};
      this.fetchCodes();
    });
  }
  /**
   * @description 禁用或启用账号
   */
  private banApplyAccount(code) {
    const action: any = code["状态"] === "禁用" ? "启用" : "禁用";
    if (action === "禁用") {
      this.$confirm("禁用后无法邀请他人，确定要禁用吗？")
        .then(() => {
          const params: any = {
            code_id: code.code_id,
            action,
          };
          BanApplyInviteCode(this, params).then((data: any) => {
            this.$message.success(action + "成功");
            this.fetchCodes();
          });
        })
        .catch((e) => {
          console.log(e);
        });
    } else {
      const params: any = {
        code_id: code.code_id,
        action,
      };
      BanApplyInviteCode(this, params).then((data: any) => {
        this.$message.success(action + "成功");
        this.fetchCodes();
      });
    }
  }
  /**
   * @description 初始化
   */
  private mounted() {
    this.filter = this.localFilter;
    this.fetchCodes();
  }
}
